module.exports = __webpack_public_path__ + "img/ps_big1.fd43d1d0.gif";